import React, { useRef } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { FormGroup } from 'react-bootstrap';
import CommonAction from './CommonAction';

export function Label({
  labelColours,
  label,
  placeHolder,
  value,
  fromForm,
  duplicatingItem,
  onChange,
  gridIndex,
  pageIndex,
  editingInput,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const multiSelectRef = useRef(null);

  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const filterData = labelColours?.filter((ele) => ele.isLabelColourChecked);

  const options = filterData.map((item) => {
    return {
      label: item.colourName,
      value: item.colourHexCode,
    };
  });
  let settingClass = '';
  if (otherConfiguration?.bold) {
    settingClass = 'bold ';
  }
  if (otherConfiguration?.alignment) {
    settingClass = `${settingClass}text-${otherConfiguration?.alignment}`;
  }
  const handleDropdownToggle = () => {
    // Check if the options dropdown is open by checking if the dropdown element exists in the DOM
    if (multiSelectRef.current) {
      const dropdownElement = multiSelectRef.current.querySelector('.dropdown-content');
      setParentGridZIndex(dropdownElement, gridIndex);
    }
  };

  return (
    <FormGroup className="flex-fill position-relative select-min-height">
      <div ref={multiSelectRef} className="custom-react-select-po">
        <p className={`mb-1 fs-custom-module field-lbl asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
        {fromForm && onElement && (
          <CommonAction
            editingInput={editingInput}
            gridIndex={gridIndex}
            pageIndex={pageIndex}
            showDelete={showDelete}
            deleteItem={deleteItem}
            handleDuplicateItem={handleDuplicateItem}
            supplierVisible={supplierVisible}
            handleSupplierPermission={handleSupplierPermission}
            handleStaticGrid={handleStaticGrid}
            isStatic={isStatic}
          />
        )}
        <MultiSelect
          options={options}
          className={`custom-multiselect w-100 ${settingClass}`}
          value={value || []}
          labelledBy={placeHolder}
          overrideStrings={{
            selectSomeItems: placeHolder,
          }}
          onChange={(e) => onChange(e, label, gridIndex, pageIndex)}
          onMenuToggle={handleDropdownToggle}
        />
      </div>
    </FormGroup>
  );
}
export default Label;
